export default "__VITE_ASSET__6195bbca__"